import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchConfigValues = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.table_name) params.set("table_name", filters.table_name);
    if (filters.column_name) params.set("column_name", filters.column_name);

    const queryString = params.toString();
    const response = await apiFetch(`${API_BASE_ADMIN}/config/admin${queryString ? `?${queryString}` : ""}`);
    return await response.json();
};

export const updateConfigValue = async (id, data) => {
    return await apiFetch(`${API_BASE_ADMIN}/config/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
};

export const deleteConfigValue = async (id) => {
    return await apiFetch(`${API_BASE_ADMIN}/config/admin/${id}`, {
        method: "DELETE",
    });
};

export const addConfigValue = async (data) => {
    return await apiFetch(`${API_BASE_ADMIN}/config/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
};
